import "./BoilerInstallation.module.css";
import Header from "@/reusable_sections/Header";
import BoilerInstallationDublin from "./sections/BoilerInstallationDublin";
import TrustedBoilerBrandsWeInstall from "./sections/TrustedBoilerBrandsWeInstall";
import RequestAFreeBoilerQuote from "./sections/RequestAFreeBoilerQuote";
import Footer from "@/reusable_sections/Footer";
export default function BoilerInstallationPage() {
  return <div>
      <Header />
      <BoilerInstallationDublin />
      <TrustedBoilerBrandsWeInstall />
      <RequestAFreeBoilerQuote />
      <Footer />
    </div>;
}